// extracted by mini-css-extract-plugin
export default {"wrapper":"AgentReferral_wrapper__KoNM5","code":"AgentReferral_code__J3QCQ","linkRow":"AgentReferral_linkRow__e9OHd"};